import { render, staticRenderFns } from "./DetailDemandePersonneMorale.vue?vue&type=template&id=68565400&"
import script from "./DetailDemandePersonneMorale.vue?vue&type=script&lang=js&"
export * from "./DetailDemandePersonneMorale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports